import { CheckboxField, RadioField, TextField } from "components/RenderInput"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray } from "redux-form"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"

export const renderAnswersForm = ({
  fields,
  meta: { error, submitFailed },
  handleFieldFocus,
  hasReplies,
}) => (
  <>
    {submitFailed && error && <span className={"input-error"}>{error}</span>}
    {fields.map((answer, index) => (
      <Row key={index} className="my-2 ms-1">
        <Col className="my-1">
          <Field
            name={`${answer}.answer`}
            component={TextField}
            placeholder={`Answer ${index + 1}`}
            style={{ display: "inline" }}
            onFocus={handleFieldFocus}
          />
        </Col>
        {fields.length > 2 && (
          <Col xs="auto" className="d-flex justify-content-end mt-2">
            <i
              className="bx bx-sm bx-x"
              style={{
                paddingLeft: "5px",
                cursor: "pointer",
              }}
              onClick={
                hasReplies
                  ? () => {}
                  : () => {
                      const answer = fields.get(index)
                      if (answer?.id) {
                        fields.splice(index, 1, { id: answer.id, answer: "" })
                      } else {
                        fields.remove(index)
                      }
                    }
              }
            />
          </Col>
        )}
      </Row>
    ))}
    <Row>
      <Col>
        <p
          style={{ cursor: "pointer" }}
          onClick={
            hasReplies ? () => {} : () => fields.push({ id: null, answer: "" })
          }
        >
          + Another Answer
        </p>
      </Col>
    </Row>
  </>
)

export const renderQuestionsForm = ({
  fields,
  handleFieldFocus,
  hasReplies,
}) => {
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      fields.swap(fromIndex, toIndex)
    },
    nodeSelector: "div.card",
    handleSelector: "div.card",
    lineClassName: "dragDropLine",
  }
  return (
    <ReactDragListView {...dragProps}>
      {fields.map((question, index) => {
        const formValues = fields.get(index)
        return (
          <Card style={{ border: "1px solid black" }} key={index}>
            <CardHeader className="h5 bg-transparent border-bottom ">
              <Row>
                {fields.length > 1 && (
                  <Col xs="auto">
                    <i
                      className="bx bx-sm bx-menu"
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                )}
                <Col style={{ display: "inline" }}>
                  <p
                    style={{ display: "inline", verticalAlign: "text-bottom" }}
                  >
                    Form Builder Question #{index + 1}:
                  </p>
                </Col>
                {fields.length > 1 && (
                  <Col xs="auto" style={{ display: "inline" }}>
                    <i
                      className="bx bx-sm bx-x"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={
                        hasReplies
                          ? () => {}
                          : () => {
                              fields.remove(index)
                            }
                      }
                    />
                  </Col>
                )}
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <Field
                    name={`${question}.question`}
                    component={TextField}
                    onFocus={handleFieldFocus}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Field
                    name={`${question}.optional`}
                    component={CheckboxField}
                    label="Required question"
                    onChange={handleFieldFocus}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <h5>Answer Type:</h5>
                </Col>
              </Row>
              <Row>
                <Col xl={12} className="my-1">
                  <Field
                    name={`${question}.answerType`}
                    component={RadioField}
                    value="1"
                    label="Multiple Choice"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
                {formValues.answerType === "1" && (
                  <Col xl={12} className="my-1 ms-3">
                    <Field
                      name={`${question}.multipleAnswer`}
                      component={CheckboxField}
                      label="Allow users to choose more than one answer when answering this form builder question"
                      onChange={handleFieldFocus}
                    />
                  </Col>
                )}
                <Col xl={12} className="my-1">
                  <Field
                    name={`${question}.answerType`}
                    component={RadioField}
                    value="2"
                    label="Text Answer"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
                {formValues.answerType === "2" && (
                  <>
                    <Col xl={12} className="my-1 ms-3">
                      <Field
                        name={`${question}.textAnswerType`}
                        component={RadioField}
                        value="1"
                        label="short (single line)"
                        type="radio"
                        onChange={handleFieldFocus}
                      />
                    </Col>
                    <Col xl={12} className="my-1 ms-3">
                      <Field
                        name={`${question}.textAnswerType`}
                        component={RadioField}
                        value="2"
                        label="long (paragraph)"
                        type="radio"
                        onChange={handleFieldFocus}
                      />
                    </Col>
                  </>
                )}
                <Col xl={12} className="my-1">
                  <Field
                    name={`${question}.answerType`}
                    component={RadioField}
                    value="3"
                    label="Add Single File"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
                <Col xl={12} className="my-1">
                  <Field
                    name={`${question}.answerType`}
                    component={RadioField}
                    value="4"
                    label="Add Multiple Files"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
              </Row>
              {formValues.answerType === "1" && (
                <FieldArray
                  name={`${question}.answers`}
                  component={renderAnswersForm}
                  handleFieldFocus={handleFieldFocus}
                  hasReplies={hasReplies}
                />
              )}
              {formValues.answerType === "2" && (
                <p style={{ color: "silver" }} className="mt-3">
                  The answer will be filled in by the user responding to the
                  form builder
                </p>
              )}
            </CardBody>
          </Card>
        )
      })}
    </ReactDragListView>
  )
}
